import { useSearchParams } from "react-router-dom"
import { useAppDependencies } from "../../context/AppContext"
import Layout from "../Layout"
import SearchPage from "../search/SearchPage"
import OldUrlRedirect from "./OldUrlRedirect"
import PathRouter from "../../navigation/PathRouter"

/**
 * Home page wrapper that checks for old URL patterns and redirects if needed,
 * otherwise renders the home page.
 */
export default function HomePageWithRedirect() {
    const [searchParams] = useSearchParams()
    const path = searchParams.get('path')
    const deps = useAppDependencies()
    
    // If there's a path query param, it's an old URL pattern - redirect
    if (path) {
        return <OldUrlRedirect />
    }
    
    // Otherwise, render the home page
    return (
        <Layout>
            <SearchPage
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
            />
        </Layout>
    )
}

